import { render, staticRenderFns } from "./CardUpdateCardGrid.vue?vue&type=template&id=22fbe07a&scoped=true"
import script from "./CardUpdateCardGrid.vue?vue&type=script&lang=js"
export * from "./CardUpdateCardGrid.vue?vue&type=script&lang=js"
import style0 from "./CardUpdateCardGrid.vue?vue&type=style&index=0&id=22fbe07a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fbe07a",
  null
  
)

export default component.exports